module.exports = __webpack_public_path__ + "img/ingvild.e25ead81.jpg";